/*19 apps to add (2026-10-16 00:30:12) *//* module data info: ModulosCheck / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio ModulosCheck}*/

var WsModulesCheck = true;

/*{Modulo App Fim ModulosCheck}*/

/* module data info: ExibeHome / all app added at (2026-10-16 00:30:12) *//* module data info: CarrinhosAbandados / none app added at (2026-10-16 00:30:12) *//* module data info: SeloReclameAqui / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio SeloReclameAqui}*/

setTimeout(() => {
  console.log("Selo ReclameAqui Inserido Vrs1.2");
  try {
    wsMain.modules['footer-badges'].create([{
      name: 'Reclame Aqui',
      url: null,
      image: null,
      content: '<div id="reputation-ra"></div>'
    }]);

    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.id = 'ra-embed-reputation';
    s.src = 'https://s3.amazonaws.com/raichu-beta/selos/bundle.js';
    s.setAttribute('data-id', 'WGY4MFp3TjQtMy1pbm1UcTpoaWxkYS1hdGFjYWRv');
    s.setAttribute('data-target', 'reputation-ra');
    s.setAttribute('data-model', '2');
    document.getElementById('reputation-ra').appendChild(s);
  } catch (e) { console.error('[selo-ra]', e); }
}, 1000);

/*{Modulo App Fim SeloReclameAqui}*/

/* module data info: WsCountAccess / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio WsCountAccess}*/

function controle_acesso() {
    
    let LV_ID = document.querySelector('#HD_LV_ID').value;

    function controleAcessoData() {
        const wsgooArr = wsgoo.split(',');
        return wsgooArr.map(elm => ({ event: elm }) )
    }   
    
    async function fetchControleAcesso() {
        try {
            const events = controleAcessoData();
            const url = 'https://analytics-access.wslojas.com.br/events/save';
            const config = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                  },
                body: JSON.stringify({events: events}), 
            }
    
            const response = await fetch( url, config );  
        } catch (error) {
            /*console.log(error)*/
        }
    }

    try {
        const blockedStores = '|29739|29373|10232|1604|122|24465|22496|2855|97|24534|5167|27521|29373|26207|23192|23824|28796|5998|';
        if (blockedStores.indexOf(`|${LV_ID}|`) < 0){
            fetchControleAcesso();
        }
    } catch (error) {
        
    }
}

setTimeout(() => {
    console.log('controle de acesso iniciado');
    controle_acesso();
}, 4000);

/*{Modulo App Fim WsCountAccess}*/

/* module data info: ProductRecomend / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio ProductRecomend}*/

/*Versão 03-06-2026-0003*/
let wsAppRecomend = true;
setTimeout(() => {
  wsMain.createModule({
    name: "suggestion-slider",
    function: "get",

    subFunctions: {
      createAncors() {
        const pageWidth = window.innerWidth;

        if (!(window.WsApi3Apps && window.WsApi3Apps.productRecomendDrawer)) {
          let topo = document.querySelector("header .header-top .cart-holder");

          if (pageWidth < 1000) {
            topo = document.querySelector(
              "header .header-top .cart-holder .mobile-menu-side:last-of-type"
            );
          }

          const cartDrawerAncor =
            pageWidth < 1000 ? "cartDrawerMobile" : "cartDrawer";

          if (topo) {
            if (!topo.querySelector(`[cart-suggestion-slider="${cartDrawerAncor}"]`)) {
              const cartDrawerAncorEl = wsMain.tools.createElm({
                type: "div",
                attrs: {
                  "cart-suggestion-slider": pageWidth < 1000 ? "cartDrawerMobile" : "cartDrawer",
                },
              });

              topo.insertBefore(cartDrawerAncorEl, topo.querySelector(".cart-items-holder"));
            }
          }
        }

        const etapasObj = {
          carrinho() {
            let container = document.querySelector(
              ".PageCheckoutCar .login-cart-row .container"
            );

            let existAncor = document.querySelector(
              ".PageCheckoutCar .login-cart-row [cart-suggestion-slider]"
            );

            if (typeof newCartVersion !== "undefined") {
              container = document.querySelector("#ws-carrinhoNovo");
              existAncor = document.querySelector(
                '#ws-carrinhoNovo [ws-cart-app="app-suggestion"]'
              );

              console.log("[suggestion] createAncors | newCart | existAncor:", !!existAncor, "| jaTemAnchor:", existAncor ? !!existAncor.querySelector("[cart-suggestion-slider]") : "n/a");

              if (existAncor) {
                if (!existAncor.querySelector("[cart-suggestion-slider]")) {
                  const suggestionAncor = wsMain.tools.createElm({
                    type: "div",
                    attrs: {
                      "cart-suggestion-slider":
                        pageWidth < 1000 ? "checkoutMobile" : "checkout",
                    },
                  });
                  existAncor.append(suggestionAncor);
                }
                return;
              }
            }

            if (!container || existAncor) return;

            const fatherContainer = container.parentNode;
            const suggestionAncor = wsMain.tools.createElm({
              type: "div",
              attrs: {
                "cart-suggestion-slider":
                  pageWidth < 1000 ? "checkoutMobile" : "checkout",
              },
            });

            fatherContainer.insertBefore(suggestionAncor, container);
          },
        };

        const etapa = (document.querySelector("#HdEtapaLoja")?.value || "").toLowerCase();

        console.log("[suggestion] createAncors | etapa:", etapa);

        try {
          etapasObj[etapa] ? etapasObj[etapa]() : null;
        } catch (error) {
          console.log("test ~ createAncors ~ error:", error);
        }
      },

      deepEqualObject(obj1, obj2) {
        if (obj1 === obj2) return true;

        if (
          typeof obj1 !== "object" ||
          obj1 === null ||
          typeof obj2 !== "object" ||
          obj2 === null
        ) {
          return false;
        }

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        for (const key of keys1) {
          if (
            !keys2.includes(key) ||
            !this.deepEqualObject(obj1[key], obj2[key])
          ) {
            return false;
          }
        }

        return true;
      },

      arraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;

        for (let i = 0; i < arr1.length; i++) {
          if (!this.deepEqualObject(arr1[i], arr2[i])) {
            return false;
          }
        }

        return true;
      },

      createProds(prod) {
        if (!prod) return;

        const shopId = document.querySelector("#HD_LV_ID").value;
        const afterFunction = 'wsMain.modules[&quot;cart-drawer&quot;].changeState(false, true)';
        const buttonLink = `javascript:void(wsFuncBtBuyOnList('${shopId}', '${prod.id}', '${afterFunction}'))`;

        const prodPrice = prod?.precos?.preco_promocao
          ? wsMain.data.treatPrice(prod.precos.preco_promocao)
          : wsMain.data.treatPrice(prod.precos.preco);

        let prodImage = `<span data-wsjs-icon="noimage"></span>`;
        let prodClass = `suggestion__image-link whithout-image`;

        if (prod.fotos && prod.fotos.length !== 0) {
          prodClass = `suggestion__image-link`;
          prodImage = `<img src="${prod.fotos[0]}">`;
        }

        return wsMain.tools.createElm({
          type: "div",
          attrs: {
            class: "suggestion-prod",
          },
          innerHTML: `
            <div class="suggestion__image-container">
              <a class="${prodClass}" href="${prod.links["ver_produto"]}">
                ${prodImage}
              </a>
            </div>
            <div class="suggestion__infos-container">
              <p class="infos-container__name">${prod.nome}</p>
              <p class="infos-container__price">${prodPrice}</p>
              <a class="suggestion__btn" href="${buttonLink}">Adicionar</a>
            </div>
          `,
        });
      },
    },

    async get() {
      try {
        console.log("modulo de leve tambem iniciado");

        const prodsArr = await ApiWS.Calls.listProducts.suggestion();

        console.log("[suggestion] get | prodsArr:", Array.isArray(prodsArr) ? prodsArr.length + " produtos" : prodsArr);

        if (Array.isArray(prodsArr) && prodsArr.length === 0) {
          wsMain.modules["suggestion-slider"].clear();
          return false;
        }

        if (!Array.isArray(prodsArr)) {
          setTimeout(() => {
            wsMain.modules["suggestion-slider"].get();
          }, 1000);
          return false;
        }

        wsMain.modules["suggestion-slider"].create(prodsArr);
        return wsMain.modules["suggestion-slider"].watching();
      } catch (error) {
        console.log("test ~ get ~ error:", error);
        return false;
      }
    },

    async watching(prodsRecursive = []) {
      try {
        const getCartProducts = () =>
          wsMain.globalData?.infoCart?.products ?? window.cartJson?.products;

        if (typeof getCartProducts() === "undefined") {
          setTimeout(() => {
            wsMain.modules["suggestion-slider"].watching();
          }, 1000);
          return false;
        }

        const checkCart = async () => {
          const arrQtdItensCartNow = getCartProducts();

          if (!Array.isArray(arrQtdItensCartNow)) {
            wsMain.modules["suggestion-slider"].clear();
            wsMain.modules["suggestion-slider"].watching(prodsRecursive);
            return;
          }

          if (
            !wsMain.modules["suggestion-slider"].subFunctions.arraysEqual(
              arrQtdItensCartNow,
              prodsRecursive
            )
          ) {
            const prodsToRecursive = getCartProducts() || [];
            const prodsArr = await ApiWS.Calls.listProducts.suggestion();
            wsMain.modules["suggestion-slider"].update(prodsArr, true);
            wsMain.modules["suggestion-slider"].watching(prodsToRecursive);
            return;
          }

          wsMain.modules["suggestion-slider"].watching(prodsRecursive);
        };

        setTimeout(checkCart, 1000);
        return true;
      } catch (error) {
        console.log("test ~ watching ~ error:", error);
        return false;
      }
    },

    async create(prodsArr, update) {
      try {
        if (!Array.isArray(prodsArr) || prodsArr.length === 0) return;

        wsMain.modules["suggestion-slider"].subFunctions.createAncors();

        const sliderOptionsObj = {
          checkout() {
            return `
              slides.perView:3.4;
              slides.spacing:20;
              dots:false;
              loop:false;
            `;
          },
          cartDrawer() {
            return `
              slides.perView:1.4;
              slides.spacing:20;
              dots:false;
              loop:false;
            `;
          },
          checkoutMobile() {
            return `
              slides.perView:1;
              slides.spacing:20;
              dots:false;
              loop:false;
            `;
          },
          cartDrawerMobile() {
            return `
              slides.perView:1;
              slides.spacing:20;
              dots:false;
              loop:false;
            `;
          },
        };

        const pageWidth = window.innerWidth;
        const cartDrawerAncor =
          pageWidth < 800 ? "cartDrawerMobile" : "cartDrawer";

        const allAncors = update
          ? document.querySelectorAll(
              `[cart-suggestion-slider="${cartDrawerAncor}"]`
            )
          : document.querySelectorAll("[cart-suggestion-slider]");

        console.log("[suggestion] create | allAncors:", allAncors.length, "| update:", !!update);

        allAncors.forEach((ancor) => {
          if (!ancor) return;

          const ancorAttrValue = ancor.getAttribute(
            "cart-suggestion-slider"
          );

          const dataWsjsSlide = sliderOptionsObj[ancorAttrValue]
            ? sliderOptionsObj[ancorAttrValue]()
            : null;

          ancor.setAttribute("data-wsjs-slide", dataWsjsSlide);
          if (!dataWsjsSlide) return;

          ancor.innerHTML = "";

          ancor.append(
            wsMain.tools.createElm({
              type: "div",
              attrs: { class: "container" },
            })
          );

          const ancorContainer = ancor.querySelector(".container");

          ancorContainer.append(
            wsMain.tools.createElm({
              type: "div",
              attrs: { class: "suggestion__title" },
              innerHTML: `<h2>Aproveite e leve também</h2>`,
            }),
            wsMain.tools.createElm({
              type: "div",
              attrs: { class: "suggestion__sliderProds" },
            })
          );

          const containerToProds = ancor.querySelector(
            ".suggestion__sliderProds"
          );

          prodsArr.forEach((prod) => {
            containerToProds.append(
              wsMain.modules["suggestion-slider"].subFunctions.createProds(
                prod
              )
            );
          });

          const sliderOptions = wsMain.tools.getWsData(ancor, "slide");
          const [sliderVrf, slider] = wsMain.tools.createSlide(containerToProds, sliderOptions);
          if (sliderVrf) slider.update();
        });

        wsMain.modules["suggestion-slider"].handlingCheckoutPage();
        return true;
      } catch (error) {
        console.log("test ~ create ~ error:", error);
        return false;
      }
    },

    async update(prodsArr, update) {
      wsMain.modules["suggestion-slider"].clear(update);
      wsMain.modules["suggestion-slider"].create(prodsArr, update);
    },

    async clear(update) {
      try {
        const pageWidth = window.innerWidth;
        const cartDrawerAncor =
          pageWidth < 800 ? "cartDrawerMobile" : "cartDrawer";

        const allAncors = update
          ? document.querySelectorAll(
              `[cart-suggestion-slider="${cartDrawerAncor}"]`
            )
          : document.querySelectorAll("[cart-suggestion-slider]");

        allAncors.forEach((ancor) => {
          if (ancor) ancor.innerHTML = "";
        });

        return true;
      } catch (error) {
        console.log("test ~ clear ~ error:", error);
        return false;
      }
    },

    handlingCheckoutPage() {
      const etapa = (document.querySelector("#HdEtapaLoja")?.value || "").toLowerCase();
      if (etapa !== "carrinho") return;

      document
        .querySelectorAll(
          '[cart-suggestion-slider="checkout"] .suggestion__btn'
        )
        .forEach((btn) => {
          btn.addEventListener("click", () => {
            setTimeout(() => window.location.reload(), 500);
          });
        });
    },
  });

  wsMain.modules["suggestion-slider"].get();
}, 3000);

/*{Modulo App Fim ProductRecomend}*/

/* module data info: ModalNovo / all app added at (2026-10-16 00:30:12) *//* module data info: MacHtmlTag / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio MacHtmlTag}*/

(function () {
  try {
    const ua = navigator.userAgent || '';
    const plat = (navigator.platform || '').toLowerCase();
    const uaDataPlat = (navigator.userAgentData && navigator.userAgentData.platform)
      ? navigator.userAgentData.platform.toLowerCase()
      : '';

    let isMac = uaDataPlat === 'macos'
      || /macintosh|mac os x|macintel/.test(ua.toLowerCase())
      || plat.includes('mac');

    const isiPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    if (isMac && !isiPadOS) {
      document.documentElement.classList.add('os-mac');
    }

    const isSafari = /^((?!chrome|crios|edg|opr|android|fxios).)*safari/i.test(ua);
    if (isMac && !isiPadOS && isSafari) {
      document.documentElement.classList.add('browser-safari');
    }
  } catch (e) {}
})();

/*{Modulo App Fim MacHtmlTag}*/

/* module data info: AdvancedSearch / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio AdvancedSearch}*/

var searchAdvanced = true;

window.setTimeout(() => {
  try {
    wsMain.createModule({
      name: "advanced-search",
      function: "get",
      wsjsOptions: {
        limitToScroll: 8,
        blur: false,
        "suspension-points": true,
        prodsTitleLimits: 3,
        maxProds: 10,
        mobileSuggestion: 5,
        autocomplete: true,
        busca_com_voz: true,
        produtos: true,
        sugestoes: true,
        mais_buscados: [],
      },
      subfunctions: {
        actualInputWord: "",
        actualData: "",
        actualFetchedProducts: {},
        lastFetchedProd: [],
        lastFetchedWord: "",
        actualFetchedSuggestions: [],
        wordToViewAll: "",
        storeID: "",
        secondsToSearch: 1500,
        currentIndex: -1,
        /* Função para criar a div de resultados e adicioná-la ao DOM */
        createResultsDiv() {
          const sugestoesExist =
            wsMain.modules["advanced-search"].wsjsOptions["sugestoes"];
          const produtosExist =
            wsMain.modules["advanced-search"].wsjsOptions["produtos"];

          const resultsDiv = document.createElement("div");
          resultsDiv.id = "advanced-search-results";
          resultsDiv.setAttribute("search-suggestions-type", "default");
          resultsDiv.setAttribute("show-adv-suggestions", sugestoesExist);
          resultsDiv.setAttribute("show-adv-products", produtosExist);

          document.body.appendChild(resultsDiv);
          return resultsDiv;
        },
        /* Função para mostrar a div de resultados com um título */
        showResultsDiv(div, content = "", title = "", attr = "") {
          div.style.display = "flex";
          if (attr) div.setAttribute("search-suggestions-type", attr);
          div.innerHTML = title ? `<h2>${title}</h2>${content}` : content;
        },
        /* Função para esconder a div de resultados */
        hideResultsDiv(div) {
          div.innerHTML = "";
          div.style.display = "none";
        },
        /* Função para obter o histórico de buscas do localStorage */
        getSearchHistory() {
          const history = localStorage.getItem("searchHistory");
          return history ? JSON.parse(history) : [];
        },
        /* Função para salvar um termo de busca no localStorage */
        saveSearchTerm(term) {
          const history =
            wsMain.modules["advanced-search"].subfunctions.getSearchHistory();
          if (term && !history.includes(term)) {
            history.unshift(term);
            if (history.length > 5) {
              history.pop();
            }
            localStorage.setItem("searchHistory", JSON.stringify(history));
          }
        },
        /* Função para configurar o botão "X" para limpar o campo de entrada */
        configureClearButton(input, clearButton) {
          input.addEventListener("input", () => {
            if (input.value.length > 0) {
              clearButton.style.display = "flex";
            } else {
              clearButton.style.display = "none";
            }
          });

          clearButton.addEventListener("click", () => {
            wsMain.modules[
              "advanced-search"
            ].subfunctions.actualFetchedSuggestions = [];
            input.value = "";
            clearButton.style.display = "none";
            input.focus();
          });
        },
        /* Função para exibir o histórico de buscas e os termos mais procurados */
        displaySearchHistoryAndMostSearched(input, div) {
          const history =
            wsMain.modules["advanced-search"].subfunctions.getSearchHistory();
          const mostSearched =
            wsMain.modules["advanced-search"].wsjsOptions.mais_buscados;
          if (history.length === 0 && mostSearched.length === 0) {
            return;
          }

          const suspensionPoints =
            wsMain.modules["advanced-search"].wsjsOptions["suspension-points"];

          /* Cria o HTML para o histórico de busca */
          let historyHtml = "";
          if (history.length > 0) {
            historyHtml = '<p class="titleModulo">Pesquisas recentes</p>';
            historyHtml += history
              .map(
                (item) => `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(item)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                suspension-points="${suspensionPoints}">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <path id="Caminho_9585" data-name="Caminho 9585" d="M1972,5716v6l4,2m6-2a10,10,0,1,1-10-10A10,10,0,0,1,1982,5722Z" transform="translate(-1961 -5711)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                </span>
                ${item.trim()}</a>`
              )
              .join("");
          }

          /* Cria o HTML para os termos mais procurados */
          if (mostSearched.length > 0) {
            let mostSearchedHtml = '<p class="titleModulo">Mais procurados</p>';
            mostSearchedHtml += mostSearched
              .map(
                (item) => `<a
                  href="/busca?s=${wsMain.modules[
                    "advanced-search"
                  ].subfunctions.normalizeQuery(item)}" 
                  class="advanced-search-suggestion">
                  <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                    <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                  </svg>

                  ${item}</a>`
              )
              .join("");
            historyHtml += mostSearchedHtml;
          }

          /* Mostra o conteúdo no elemento de resultados */
          wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
            div,
            historyHtml,
            "",
            "historySearch"
          );
          wsMain.modules[
            "advanced-search"
          ].subfunctions.configureClickNavigation(input, div);
        },
        /* Função para verificar se já passou 24 horas desde a última busca pelos termos mais procurados */
        shouldFetchMostSearched() {
          const lastFetched = localStorage.getItem("lastFetchedMostSearched");
          if (!lastFetched) {
            return true;
          } /* Nunca buscou antes */

          const now = new Date();
          const lastFetchedDate = new Date(lastFetched);
          const diffInHours =
            (now - lastFetchedDate) / (1000 * 60 * 60); /* Diferença em horas */

          return diffInHours >= 24; /* True se passou mais de 24 horas */
        },
        /* Função para salvar os termos mais procurados no localStorage */
        saveMostSearched(mostSearched) {
          localStorage.setItem("mostSearched", JSON.stringify(mostSearched));
          localStorage.setItem(
            "lastFetchedMostSearched",
            new Date().toISOString()
          );
        },
        /* Função para obter os termos mais procurados do localStorage */
        getMostSearched() {
          const mostSearched = localStorage.getItem("mostSearched");
          return mostSearched ? JSON.parse(mostSearched) : [];
        },
        /* Função para mostrar o indicador de loading */
        showLoading(resultsDiv, mainContainer = false) {
          if (mainContainer) {
            const minHeight = resultsDiv.offsetHeight;

            resultsDiv.style.minHeight = `${minHeight}px`;

            const loadingDiv = `<div class="advanced-search-loading-products-container">
                <div class="advanced-search-loading-products"></div>
              </div>`;
            resultsDiv.innerHTML = loadingDiv;

            return;
          }

          const loadingDiv = `<div class="advanced-search-loading-products-container">
                <div class="advanced-search-loading-products"></div>
            </div>`;
          resultsDiv.querySelector(
            ".advanced-search-products-container"
          ).innerHTML = loadingDiv;
        },
        /* Função para remover o indicador de loading */
        hideLoading(resultsDiv) {
          const loadingDiv = resultsDiv.querySelector(
            ".advanced-search-loading-products"
          );
          if (loadingDiv) {
            loadingDiv.remove();
          }
        },
        /* Função para exibir produtos no elemento de resultados */
        displayProducts(products, productsToScroll = 2) {
          if (!products || products.length === 0) {
            return '<p class="no-prods-founded">Nenhum produto encontrado...</p>';
          }

          const productsScroll =
            wsMain.modules["advanced-search"].wsjsOptions.maxProds >
            productsToScroll
              ? "on"
              : "off";

          /* Gera o HTML para os produtos */
          return `
            <div class="advanced-search-products" products-scroll="${productsScroll}">
              ${products
                .map((product, idx) => {
                  if (
                    idx >=
                    wsMain.modules["advanced-search"].wsjsOptions.maxProds
                  ) {
                    return "";
                  }

                  return `<div class="advanced-search-product">
                  <a class="seached-prod-overlay" href="${product.url}"></a>
                  <div class="product-sugestion__image-container">
                    <img src="${product.photo}" alt="${product.name}">
                  </div>
                  <p class="advanced-search-prods-title">${product.name}</p>
                </div>`;
                })
                .join("")}
            </div>`;
        },
        /* Função para adicionar eventos de hover com atraso nas sugestões */
        addHoverListenersToSuggestions(resultsDiv) {
          const suggestions = resultsDiv.querySelectorAll(
            ".advanced-search-suggestion"
          );
          const secondsToSearch =
            wsMain.modules["advanced-search"].subfunctions.secondsToSearch;

          suggestions.forEach((suggestion, idx) => {
            let hoverTimeout;
            let loadingTimeout;

            suggestion.addEventListener("mouseenter", () => {
              const query = suggestion.textContent.trim();
              const input = document.getElementById("input-busca");
              wsMain.modules["advanced-search"].subfunctions.currentIndex = idx;

              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );

              if (
                wsMain.modules["advanced-search"].subfunctions
                  .actualFetchedProducts[query]
              ) {
                const productsContainer = resultsDiv.querySelector(
                  ".advanced-search-products-container"
                );
                if (productsContainer) {
                  productsContainer.innerHTML =
                    wsMain.modules[
                      "advanced-search"
                    ].subfunctions.actualFetchedProducts[query];
                }
                return;
              }

              loadingTimeout = setTimeout(() => {
                wsMain.modules["advanced-search"].subfunctions.showLoading(
                  resultsDiv
                );
              }, 300);

              /* Inicia o timer de 3 segundos ao passar o mouse na sugestão */
              hoverTimeout = setTimeout(() => {
                const input = document.getElementById("input-busca");
                wsMain.modules["advanced-search"].subfunctions.currentIndex =
                  idx;

                wsMain.modules[
                  "advanced-search"
                ].subfunctions.updateSuggestionHighlight(
                  suggestions,
                  wsMain.modules["advanced-search"].subfunctions.currentIndex,
                  input
                );

                wsMain.modules["advanced-search"].subfunctions.fetchProducts(
                  query,
                  resultsDiv
                ); /* Busca os produtos para a sugestão */
              }, secondsToSearch);
            });

            suggestion.addEventListener("mouseleave", () => {
              clearTimeout(hoverTimeout);
              clearTimeout(loadingTimeout);

              if (
                wsMain.modules["advanced-search"].subfunctions.lastFetchedProd
                  .length > 0 &&
                wsMain.modules["advanced-search"].subfunctions
                  .lastFetchedWord &&
                wsMain.modules["advanced-search"].wsjsOptions.produtos
              ) {
                const productsContainer = resultsDiv.querySelector(
                  ".advanced-search-products-container"
                );
                if (productsContainer) {
                  const word =
                    wsMain.modules["advanced-search"].subfunctions
                      .lastFetchedWord;
                  const lastProductHtml =
                    wsMain.modules["advanced-search"].subfunctions
                      .lastFetchedProd[0][word];
                  productsContainer.innerHTML = lastProductHtml;
                }
                return;
              }
            });
          });
        },
        normalizeQuery(query) {
          if (typeof query !== "string") {
            return;
          }

          return query
            .trim()
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9\s-]/g, "")
            .replace(/\s+/g, " ");
        },
        viewAllResultsLink(query) {
          return `<a href="/busca?s=${query}"
          class="view-all-results-link" 
          title="Resultados da busca">Ver todos os resultados</a>`;
        },
        /* Função para autocompletar no input */
        autocompleteInput(input, suggestions, resultsDiv) {
          if (!wsMain.modules["advanced-search"].wsjsOptions["autocomplete"]) {
            return;
          }

          const currentValue = input.value.trim().toLowerCase();

          /* Pega a última palavra digitada */
          const words = currentValue.split(" ");
          const lastWord = words[words.length - 1];

          if (!lastWord) return;

          /* Busca uma palavra correspondente dentro das sugestões */
          for (const suggestion of suggestions) {
            const wordsInSuggestion = suggestion.search
              .toLowerCase()
              .split(" ");

            const match = wordsInSuggestion.find((word) =>
              word.startsWith(lastWord)
            );

            if (match) {
              /* Monta a nova string com a sugestão */
              const autocompleteText = match.slice(lastWord.length);
              words[words.length - 1] = lastWord + autocompleteText;
              input.value = words.join(" ");

              /* Seleciona apenas o texto sugerido */
              input.setSelectionRange(currentValue.length, input.value.length);

              wsMain.modules["advanced-search"].subfunctions.actualInputWord =
                input.value;
              break; // Para no primeiro match encontrado
            }
          }

          const suggestionsDiv = resultsDiv.querySelector(
            ".advanced-search-suggestions-container .advanced-search-suggestions-options"
          );

          suggestionsDiv.setAttribute("autocomplete-inserted", "true");
        },
        /* Função para buscar os termos mais procurados do servidor e armazená-los */
        async fetchAndSaveMostSearched() {
          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=`;

          try {
            const response = await fetch(url);
            if (!response.ok) {
              console.error("Error fetching most searched terms");
              return [];
            }

            const data = await response.json();

            const mostSearched = data.most_searched || [];

            wsMain.modules["advanced-search"].subfunctions.saveMostSearched(
              mostSearched
            );
            return mostSearched;
          } catch (error) {
            console.error("Error fetching most searched terms:", error);
            return [];
          }
        },
        /* Função para atualizar apenas os produtos na div de resultados */
        async fetchProducts(query, resultsDiv) {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.lastFetchedProd.length = 0;
          wsMain.modules["advanced-search"].subfunctions.lastFetchedWord = "";

          if (!wsMain.modules["advanced-search"].wsjsOptions["produtos"]) {
            return;
          }
          const normalizedQuery =
            wsMain.modules["advanced-search"].subfunctions.normalizeQuery(
              query
            );

          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=${encodeURIComponent(
            normalizedQuery
          )}`;

          try {
            const response = await fetch(url);
            if (!response.ok) {
              console.error("Error fetching products");
              return;
            }

            wsMain.modules["advanced-search"].subfunctions.wordToViewAll =
              normalizedQuery;

            const data = await response.json();
            const productsHtml =
              wsMain.modules["advanced-search"].subfunctions.displayProducts(
                data.products
              ) +
              wsMain.modules["advanced-search"].subfunctions.viewAllResultsLink(
                wsMain.modules["advanced-search"].subfunctions.wordToViewAll
              );

            /* Atualiza apenas a seção de produtos */
            const productsContainer = resultsDiv.querySelector(
              ".advanced-search-products-container"
            );
            if (productsContainer) {
              productsContainer.innerHTML = productsHtml;
            }

            if (productsHtml && query) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.push({ [query]: productsHtml });
              wsMain.modules[
                "advanced-search"
              ].subfunctions.actualFetchedProducts[query] = productsHtml;
              wsMain.modules["advanced-search"].subfunctions.lastFetchedWord =
                query;
            }

            /* wsMain.modules['advanced-search'].subfunctions.hideLoading(resultsDiv) */
          } catch (error) {
            wsMain.modules["advanced-search"].subfunctions.hideLoading(
              resultsDiv
            );
            console.error("Error fetching products:", error);
          }
        },
        /* Atualização da função fetchSuggestions para incluir produtos */
        async fetchSuggestions(input, resultsDiv, query, force = false) {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.lastFetchedProd.length = 0;
          wsMain.modules["advanced-search"].subfunctions.lastFetchedWord = "";

          const sugestoesExist =
            wsMain.modules["advanced-search"].wsjsOptions["sugestoes"];
          const produtosExist =
            wsMain.modules["advanced-search"].wsjsOptions["produtos"];

          if (!sugestoesExist && !produtosExist) {
            return;
          }

          const normalizedQuery =
            wsMain.modules["advanced-search"].subfunctions.normalizeQuery(
              query
            );

          const lvID = wsMain.modules["advanced-search"].subfunctions.storeID;

          let host = window.location.host;
          if (host === "localhost:3000") {
            host = "flach.dev.br";
          }

          const url = `https://${host}/cadastroAJAX/buscaAjax.aspx?tipo=busca&LV_ID=${lvID}&version=json&valor=${encodeURIComponent(
            normalizedQuery
          )}`;

          try {
            let data = "";
            if (force) {
              data = wsMain.modules["advanced-search"].subfunctions.actualData;
            } else {
              const response = await fetch(url);
              if (!response.ok) {
                wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
                  resultsDiv,
                  "<p>Erro ao buscar sugestões...</p>",
                  "",
                  "suggestionSearchError"
                );
                return;
              }

              data = await response.json();
            }

            wsMain.modules["advanced-search"].subfunctions.actualData = data;
            wsMain.modules["advanced-search"].subfunctions.actualInputWord =
              query;

            const { suggestions, products } = data;
            console.log("test ~ fetchSuggestions ~ suggestions:", suggestions);

            const suspensionPoints =
              wsMain.modules["advanced-search"].wsjsOptions[
                "suspension-points"
              ];

            if (suggestions.length < 1 && products.length < 1) {
              wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
                resultsDiv,
                "",
                "",
                "suggestionSearchError"
              );
              return;
            }

            if (suggestions.length < 1) {
              suggestions.push({ search: query });
            }

            const suggestionsHtml = suggestions
              .map((item, idx) => {
                if (
                  wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion
                ) {
                  if (
                    idx <
                    wsMain.modules["advanced-search"].wsjsOptions
                      .mobileSuggestion
                  ) {
                    const position = item.search.indexOf(input.value);

                    if (position == -1) {
                      return `<a 
                      href="/busca?s=${wsMain.modules[
                        "advanced-search"
                      ].subfunctions.normalizeQuery(item.search)}" 
                      title="Sugestão de pesquisa" 
                      class="advanced-search-suggestion" 
                      onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                      suspension-points="${suspensionPoints}">
                      <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                        <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                      </svg>
                      <span>${item.search.trim()}</span>
                      </a>`;
                    }

                    const before = item.search.trim().slice(0, position);

                    const after = item.search
                      .trim()
                      .slice(position + input.value.length);

                    return `<a 
                    href="/busca?s=${wsMain.modules[
                      "advanced-search"
                    ].subfunctions.normalizeQuery(item.search)}" 
                    title="Sugestão de pesquisa" 
                    class="advanced-search-suggestion" 
                    onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                    suspension-points="${suspensionPoints}">
                    <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                      <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                    </svg>
                    <span>${before ? `<strong>${before}</strong>` : ""}<span>${
                      input.value
                    }</span>${after ? `<strong>${after}</strong>` : ""}</span>
                    </a>`;
                  }

                  return "";
                }

                return `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(item.search)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${item.search.trim()}</span>
                </a>`;
              })
              .join("");

            if (suggestions[0].search) {
              wsMain.modules["advanced-search"].subfunctions.wordToViewAll =
                normalizedQuery.replace(/ /g, "-");
            }

            const suggestionsScroll =
              suggestions.length >
                wsMain.modules["advanced-search"].wsjsOptions.limitToScroll &&
              !wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion
                ? "on"
                : "off";

            let productsToScroll = 2;
            if (!sugestoesExist) {
              productsToScroll = 3;
            }

            const productsHtml =
              wsMain.modules["advanced-search"].subfunctions.displayProducts(
                products,
                productsToScroll
              ) +
              wsMain.modules["advanced-search"].subfunctions.viewAllResultsLink(
                wsMain.modules["advanced-search"].subfunctions.wordToViewAll
              );

            wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
              resultsDiv,
              `
              <div class="advanced-search-results-container">
                <div class="advanced-search-suggestions-container" suggestion-scroll="${suggestionsScroll}">
                  <div class="advanced-search-suggestions-options-container"  suggestion-scroll="${suggestionsScroll}">
                    <div class="advanced-search-suggestions-options">${
                      sugestoesExist ? suggestionsHtml : ""
                    }</div>
                  </div>
                </div>  
                <div class="advanced-search-products-container">${
                  produtosExist ? productsHtml : ""
                }</div>
              </div>
            `,
              "",
              "suggestionSearch"
            );

            if (produtosExist && normalizedQuery) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.push({
                [normalizedQuery]: productsHtml,
              });
              wsMain.modules["advanced-search"].subfunctions.lastFetchedWord =
                normalizedQuery;
            }

            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "true"
            );
            wsMain.modules["advanced-search"].subfunctions.autocompleteInput(
              input,
              suggestions,
              resultsDiv
            );
            wsMain.modules[
              "advanced-search"
            ].subfunctions.configureClickNavigation(input, resultsDiv);
            wsMain.modules[
              "advanced-search"
            ].subfunctions.addHoverListenersToSuggestions(resultsDiv);

            wsMain.modules[
              "advanced-search"
            ].subfunctions.actualFetchedSuggestions = suggestions;

            resultsDiv.style.minHeight = "";
          } catch (error) {
            wsMain.modules["advanced-search"].subfunctions.showResultsDiv(
              resultsDiv,
              '<p class="advanced-search-searching-error">Erro ao buscar sugestões...</p>',
              "",
              "suggestionSearchError"
            );
            console.error("Erro:", error);
          }
        },
        /* Função para configurar os eventos do campo de busca */
        configureSearchEvents(input, resultsDiv) {
          const debouncedFetchSuggestions = wsMain.modules[
            "advanced-search"
          ].subfunctions.debounce((query) => {
            wsMain.modules["advanced-search"].subfunctions.fetchSuggestions(
              input,
              resultsDiv,
              query
            );
          }, 2000);

          /* Mostra a div de resultados e exibe o histórico e os mais procurados ao clicar no campo de entrada */
          input.addEventListener("click", async () => {
            if (
              input.value.length > 0 &&
              wsMain.modules["advanced-search"].subfunctions.actualData &&
              wsMain.modules[
                "advanced-search"
              ].subfunctions.actualInputWord.startsWith(input.value)
            ) {
              wsMain.modules["advanced-search"].subfunctions.fetchSuggestions(
                input,
                resultsDiv,
                input.value,
                true
              );
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "true"
              );
              return;
            }

            /* realiza uma chamada para obter as palavras mais buscadas */
            /* if (wsMain.modules['advanced-search'].subfunctions.shouldFetchMostSearched()) {
              await wsMain.modules['advanced-search'].subfunctions.fetchAndSaveMostSearched();
            }*/

            wsMain.modules[
              "advanced-search"
            ].subfunctions.displaySearchHistoryAndMostSearched(
              input,
              resultsDiv
            );
            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "true"
            );
          });

          /* Busca sugestões a partir do terceiro caractere digitado com debounce */
          input.addEventListener("input", (e) => {
            const query = e.target.value.trim();
            const updateBold = wsMain.modules[
              "advanced-search"
            ].subfunctions.updateBoldInSugestions(input, resultsDiv);

            if (updateBold) {
              return;
            }
            if (query.length >= 3) {
              wsMain.modules["advanced-search"].subfunctions.showLoading(
                resultsDiv,
                true
              );

              debouncedFetchSuggestions(query);
            } else if (query.length === 0) {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.displaySearchHistoryAndMostSearched(
                input,
                resultsDiv
              );
            }
          });

          /* Salva o termo de busca ao pressionar Enter e exibe o histórico atualizado */
          input.addEventListener("keydown", (event) => {
            if (event.key === "Enter" && input.value.trim()) {
              wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
                input.value.trim()
              );
              /* wsMain.modules['advanced-search'].subfunctions.displaySearchHistoryAndMostSearched(input, resultsDiv); */
            }
          });

          if (window.innerWidth < 900) {
            input.addEventListener("focusin", () => {
              document.body.style.zoom = "1";
            });

            input.addEventListener("focusout", () => {
              document.body.style.zoom = "";
            });
          }

          /* Evento para o botão "X" (limpar campo de busca) */
          const clearButton = document.querySelector(
            ".advanced-search-clear-button"
          );
          if (clearButton) {
            clearButton.addEventListener("click", () => {
              wsMain.modules[
                "advanced-search"
              ].subfunctions.lastFetchedProd.length = 0;
              input.value = "";
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "false"
              );
              wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                resultsDiv
              );
            });
          }

          wsMain.modules[
            "advanced-search"
          ].subfunctions.configureKeyboardNavigation(input, resultsDiv);
        },
        updateBoldInSugestions(input, resultsDiv) {
          try {
            if (!input || !resultsDiv) {
              return false;
            }

            const suggestionsElements = resultsDiv.querySelectorAll(
              ".advanced-search-suggestions-options .advanced-search-suggestion > span"
            );

            if (suggestionsElements.length === 0) {
              return false;
            }

            const actualFetchedSuggestions =
              wsMain.modules["advanced-search"].subfunctions
                .actualFetchedSuggestions;

            const suggestionsList = actualFetchedSuggestions.map((sug) =>
              sug.search.trim()
            );

            const filteredSuggestions = suggestionsList.filter((word) => word);

            if (!filteredSuggestions.length) {
              return false;
            }

            const suggestionsDiv = resultsDiv.querySelector(
              ".advanced-search-suggestions-container .advanced-search-suggestions-options"
            );

            suggestionsDiv.innerHTML = "";

            const suspensionPoints =
              wsMain.modules["advanced-search"].wsjsOptions[
                "suspension-points"
              ];

            filteredSuggestions.forEach((word) => {
              const position = word.indexOf(input.value);

              if (position == -1) {
                return `<a 
                href="/busca?s=${wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(word)}" 
                title="Sugestão de pesquisa" 
                class="advanced-search-suggestion" 
                onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
                suspension-points="${suspensionPoints}">
                <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                  <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
                </svg>
                <span>${word}</span>
                </a>`;
              }

              const before = word.slice(0, position);

              const after = word.slice(position + input.value.length);

              const formattedWord = `
              <a 
              href="/busca?s=${wsMain.modules[
                "advanced-search"
              ].subfunctions.normalizeQuery(word)}" 
              title="Sugestão de pesquisa" 
              class="advanced-search-suggestion" 
              onclick="wsMain.modules['advanced-search'].subfunctions.saveSearchTerm(this.value)"
              suspension-points="${suspensionPoints}">
              <svg ico="Search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 237.76 240.91">
                <path d="m233.21 214.29-38.63-38.63c14.43-18.45 23.02-41.68 23.02-66.87C217.6 48.81 168.79 0 108.79 0S0 48.81 0 108.79 48.81 217.6 108.79 217.6c23.59 0 45.43-7.54 63.28-20.34l39.07 39.07c3.05 3.05 7.03 4.57 11.03 4.57s7.99-1.52 11.03-4.57c6.08-6.1 6.08-15.97 0-22.05ZM22.35 108.79c0-47.67 38.77-86.44 86.44-86.44s86.46 38.77 86.46 86.44-38.79 86.46-86.46 86.46-86.44-38.79-86.44-86.46Z"></path>
              </svg>
              <span>${before ? `<strong>${before}</strong>` : ""}<span>${
                input.value
              }</span>${after ? `<strong>${after}</strong>` : ""}</span>
              </a>`;

              suggestionsDiv.innerHTML += formattedWord;
            });

            if (
              suggestionsDiv.getAttribute("autocomplete-inserted") === "true"
            ) {
              return true;
            }

            wsMain.modules["advanced-search"].subfunctions.autocompleteInput(
              input,
              actualFetchedSuggestions,
              resultsDiv
            );
            wsMain.modules[
              "advanced-search"
            ].subfunctions.configureClickNavigation(input, resultsDiv);
            wsMain.modules[
              "advanced-search"
            ].subfunctions.addHoverListenersToSuggestions(resultsDiv);

            return true;
          } catch (error) {
            console.log("test ~ updateBoldInSugestions ~ error:", error);
            return false;
          }
        },
        /* Função de debounce para limitar a frequência de requisições */
        debounce(func, delay) {
          let timerId;
          return (...args) => {
            clearTimeout(timerId);
            timerId = setTimeout(() => func.apply(this, args), delay);
          };
        },
        /* Função para gerenciar a navegação com o teclado nas sugestões */
        configureKeyboardNavigation(input, resultsDiv) {
          input.addEventListener("keydown", (event) => {
            const suggestions = resultsDiv.querySelectorAll(
              ".advanced-search-suggestion"
            );
            if (suggestions.length === 0) {
              return;
            }

            if (event.key === "ArrowDown") {
              event.preventDefault();
              wsMain.modules["advanced-search"].subfunctions.currentIndex =
                (wsMain.modules["advanced-search"].subfunctions.currentIndex +
                  1) %
                suggestions.length;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
            } else if (event.key === "ArrowUp") {
              event.preventDefault();
              wsMain.modules["advanced-search"].subfunctions.currentIndex =
                (wsMain.modules["advanced-search"].subfunctions.currentIndex -
                  1 +
                  suggestions.length) %
                suggestions.length;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
            } else if (event.key === "Enter") {
              wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
                input.value.trim()
              );
              if (
                wsMain.modules["advanced-search"].subfunctions.currentIndex >= 0
              ) {
                input.value =
                  suggestions[
                    wsMain.modules["advanced-search"].subfunctions.currentIndex
                  ].textContent;
                wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                  resultsDiv
                );
                const wordToRedirect = wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(input.value);
                window.location.href = `/busca?s=${wordToRedirect}`;
              } else {
                const wordToRedirect = wsMain.modules[
                  "advanced-search"
                ].subfunctions.normalizeQuery(input.value);
                window.location.href = `/busca?s=${wordToRedirect}`;
              }
            }
          });

          document.addEventListener("click", (event) => {
            if (
              document
                .querySelector("#advanced-search-results")
                .contains(event.target) ||
              document.querySelector("#input-busca").contains(event.target)
            ) {
              return;
            }

            wsMain.modules["advanced-search"].subfunctions.currentIndex = -1;
            wsMain.modules["advanced-search"].subfunctions.changeBgState(
              "false"
            );
            wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
              resultsDiv
            );
          });

          document.addEventListener("keydown", (event) => {
            if (event.key == "Escape") {
              input.blur();
              wsMain.modules["advanced-search"].subfunctions.currentIndex = -1;
              wsMain.modules["advanced-search"].subfunctions.changeBgState(
                "false"
              );
              wsMain.modules["advanced-search"].subfunctions.hideResultsDiv(
                resultsDiv
              );
            }
          });
        },
        configureClickNavigation(input, resultsDiv) {
          const suggestions = resultsDiv.querySelectorAll(
            ".advanced-search-suggestion"
          );
          suggestions.forEach((sug, idx) => {
            sug.addEventListener("click", (e) => {
              wsMain.modules["advanced-search"].subfunctions.currentIndex = idx;
              wsMain.modules[
                "advanced-search"
              ].subfunctions.updateSuggestionHighlight(
                suggestions,
                wsMain.modules["advanced-search"].subfunctions.currentIndex,
                input
              );
              input.value = e.target.textContent;
            });
          });
        },
        /* Função para atualizar o destaque na sugestão selecionada */
        updateSuggestionHighlight(suggestions, index, input) {
          suggestions.forEach((item, i) => {
            if (i === index) {
              item.classList.add("active-search");
              input.value = item.textContent.trim();
            } else {
              item.classList.remove("active-search");
            }
          });
        },
        createRecognitionBtn(searchInput) {
          try {
            const searchHeader = document.querySelector(
              "header .search-header"
            );

            if (!searchHeader || !searchInput) {
              return;
            }

            const recogBtn = document.querySelector(".recognition-btn");

            if (!recogBtn) {
              return;
            }

            const recognition = new (window.SpeechRecognition ||
              window.webkitSpeechRecognition)();
            recognition.lang = "pt-BR";
            recognition.continuous = false;
            recognition.interimResults = false;

            recogBtn.addEventListener("click", () => {
              recognition.start();
              recogBtn.classList.add("mic-btn-listening");
            });

            recognition.onresult = (event) => {
              searchInput.value = event.results[0][0].transcript.replace(
                ".",
                ""
              );

              recogBtn.classList.remove("mic-btn-listening");
              searchInput.dispatchEvent(new Event("input", { bubbles: true }));
            };

            recognition.onerror = (event) => {
              recogBtn.classList.remove("mic-btn-listening");
            };
          } catch (error) {}
        },
        /* ativa ou desativa o fundo escuro */
        changeBgState(state) {
          const bgOption = wsMain.modules["advanced-search"].wsjsOptions.blur;

          if (!bgOption) {
            return;
          }

          const suggestionsVrf = document.querySelector(
            "#advanced-search-results .titleModulo"
          );

          if (!suggestionsVrf) {
            return;
          }

          const advancedSearchBg = document.querySelector(
            "#advanced-search-bg"
          );

          advancedSearchBg.setAttribute("advanced-search-bg-active", state);

          const body = document.querySelector("body");

          if (state == "true") body.style.overflow = "hidden";
          else body.style.overflow = "";
        },
        addZindexInput() {
          const inputBusca = document.getElementById("input-busca");

          if (inputBusca) {
            const divPai = inputBusca.parentElement;
            if (divPai) {
              divPai.style.zIndex = "3";
              divPai.style.position = "relative";
            }
          }
        },
        positionCloseBtn() {
          try {
            const input = document.getElementById("input-busca");
            const results = document.getElementById("advanced-search-results");
            const clearButton = document.querySelector(
              "#advanced-search-clear-button"
            );

            if (!input || !results || !clearButton) {
              return;
            }

            clearButton.style.display = "flex";

            const scrollbarWidth =
              wsMain.modules[
                "advanced-search"
              ].subfunctions.getScrollbarWidth();

            const rect = input.getBoundingClientRect();

            const pageWidth = window.innerWidth;

            let distanceFromTop = rect.bottom;

            if (window.innerWidth < 576) {
              results.style.minWidth = input.offsetWidth / 10 + "rem";
            }

            if (document.querySelector("header").style.position == "fixed") {
              results.style.position = "fixed";
            } else {
              results.style.position = "absolute";
            }

            results.style.top = `${distanceFromTop / 10 + 2}rem`;
            results.style.width = input.offsetWidth / 10 + "rem";
            results.style.left = rect.left / 10 + "rem";

            if (window.innerWidth < 1200) {
              results.style.top = `${distanceFromTop + 20}px`;
            }

            if (pageWidth - rect.right + 700 + scrollbarWidth < 1100) {
              results.style.right =
                (pageWidth - rect.right - scrollbarWidth) / 10 + "rem";
              results.style.left = "initial";
            }

            let clearButtonRight = (rect.width - 35) / 10;
            clearButton.style.left = `${clearButtonRight}rem`;

            /* Verifica se o botão de limpar está sobrepondo outro elemento */
            const searchBtn = document.querySelector(
              "header .search-header button"
            );
            const micButton = document.querySelector(
              "header .search-header .recognition-btn"
            );

            const rect1 = clearButton.getBoundingClientRect();
            const rect2 = searchBtn.getBoundingClientRect();

            let rect3 = "";
            if (micButton) {
              rect3 = micButton.getBoundingClientRect();
            }

            clearButton.style.display = "none";

            const horizontalTouchSearchBtn =
              rect1.right >= rect2.left && rect1.left <= rect2.right;
            const verticalTouchSearchBtn =
              rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

            let horizontalTouchMicBtn = "";
            let verticalTouchMicBtn = "";

            if (rect3) {
              horizontalTouchMicBtn =
                rect1.right >= rect3.left && rect1.left <= rect3.right;
              verticalTouchMicBtn =
                rect1.bottom >= rect3.top && rect1.top <= rect3.bottom;
            }

            if (
              (horizontalTouchSearchBtn && verticalTouchSearchBtn) ||
              (horizontalTouchMicBtn && verticalTouchMicBtn)
            ) {
              clearButtonRight = (rect.width - 70) / 10;

              input.style.paddingRight = `7.5rem`;
              clearButton.style.left = `${clearButtonRight}rem`;
            } else {
              input.style.paddingRight = `4.5rem`;
            }
          } catch (error) {}
        },
        positionMic() {
          try {
            const input = document.getElementById("input-busca");
            const micButton = document.querySelector(
              ".search-header .recognition-btn"
            );

            if (!micButton || !input) {
              return;
            }

            const rect = input.getBoundingClientRect();

            /* Verifica se o botão de limpar está sobrepondo outro elemento */
            const searchBtn = document.querySelector(
              "header .search-header button"
            );

            const rect1 = micButton.getBoundingClientRect();
            const rect2 = searchBtn.getBoundingClientRect();

            const horizontalTouch =
              rect1.right >= rect2.left && rect1.left <= rect2.right;

            const verticalTouch =
              rect1.bottom >= rect2.top && rect1.top <= rect2.bottom;

            if (horizontalTouch && verticalTouch) {
              micButton.style.left = `${(rect.width - 35) / 10}rem`;
            } else {
              input.style.paddingLeft = `4rem`;
            }
          } catch (error) {}
        },
        getScrollbarWidth() {
          const outer = document.createElement("div");
          outer.style.visibility = "hidden";
          outer.style.overflow = "scroll";
          outer.style.msOverflowStyle = "scrollbar";
          document.body.appendChild(outer);

          const inner = document.createElement("div");
          outer.appendChild(inner);

          const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

          outer.parentNode.removeChild(outer);

          return scrollbarWidth;
        },
        updateOptions(options) {
          try {
            const keys = Object.keys(options);

            if (!keys.length) {
              return;
            }

            keys.forEach((key) => {
              if (key in wsMain.modules["advanced-search"].wsjsOptions) {
                wsMain.modules["advanced-search"].wsjsOptions[key] =
                  options[key];
              }
            });
          } catch (error) {}
        },
        updateOptionsByInfoLojas() {
          try {
            /* const busca = {autocomplete: true, produtos: true, sugestoes: true, busca_com_voz: true, mais_buscados: ['fertilizante', 'estufa']} 
            Object.assign(wsMain?.globalData?.infoLoja, {busca}) */

            const buscaOptions = wsMain?.globalData?.infoLoja?.busca;

            if (!buscaOptions) {
              return;
            }

            buscaOptionsKeys = Object.keys(wsMain?.globalData?.infoLoja?.busca);

            if (!buscaOptionsKeys.length) {
              return;
            }

            buscaOptionsKeys.forEach((key) => {
              if (
                key in wsMain.modules["advanced-search"].wsjsOptions &&
                typeof wsMain?.globalData?.infoLoja?.busca[key] !==
                  "undefined" &&
                wsMain?.globalData?.infoLoja?.busca[key] !== ""
              ) {
                if (key == "mais_buscados") {
                  wsMain.modules["advanced-search"].wsjsOptions[key] =
                    wsMain?.globalData?.infoLoja?.busca[key].filter(
                      (elm) => elm
                    );
                  return;
                }

                wsMain.modules["advanced-search"].wsjsOptions[key] =
                  wsMain?.globalData?.infoLoja?.busca[key];
              }
            });
          } catch (error) {}
        },
        prodsTitleMaxLines() {
          const prodsTitleLimits =
            wsMain.modules["advanced-search"].wsjsOptions.prodsTitleLimits;

          if (prodsTitleLimits < 0) {
            return;
          }

          document.documentElement.style.setProperty(
            "--advanced-search-prods-title-line-clamp",
            prodsTitleLimits
          );
        },
        getStoreId() {
          const storeID = document.querySelector("#HD_LV_ID");

          if (!storeID) {
            return;
          }

          wsMain.modules["advanced-search"].subfunctions.storeID =
            storeID.value;
        },
        updateLocalstorageByQueryParam() {
          const urlParams = new URLSearchParams(window.location.search);
          const search = urlParams.has("s");

          if (search) {
            wsMain.modules["advanced-search"].subfunctions.saveSearchTerm(
              urlParams.get("s")
            );
          }
        },
        defaultMobileSettings() {
          if (window.innerWidth > 800) {
            return;
          }

          wsMain.modules["advanced-search"].wsjsOptions.mobileSuggestion = 3;
        },
        createDynamicAnchor() {
          const searchHeader = document.querySelector("header .search-header");

          if (!searchHeader) {
            return;
          }

          const vrfClearBtn = document.querySelector(
            "header #advanced-search-clear-button"
          );

          if (!vrfClearBtn) {
            const clearBtn = document.createElement("span");
            clearBtn.id = "advanced-search-clear-button";
            clearBtn.classList.add("advanced-search-clear-button");
            clearBtn.style.display = "none";
            clearBtn.innerHTML = "&#10005;";

            searchHeader.appendChild(clearBtn);
          }

          const vrfRecogBtn = document.querySelector(".recognition-btn");

          if (!vrfRecogBtn) {
            if (wsMain.modules["advanced-search"].wsjsOptions.busca_com_voz) {
              const recognitionBtn = document.createElement("span");
              recognitionBtn.classList.add("recognition-btn");

              recognitionBtn.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35Zm0-240Zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480Z"/></svg>
              `;

              searchHeader.appendChild(recognitionBtn);
            }
          }

          const advancedSearchBg = document.querySelector(
            "header #advanced-search-bg"
          );

          if (!advancedSearchBg) {
            const container = document.querySelector(
              "header .header-top .container"
            );

            const advancedSearchBg = document.createElement("div");
            advancedSearchBg.setAttribute("advanced-search-bg-active", "false");
            advancedSearchBg.id = "advanced-search-bg";

            container.appendChild(advancedSearchBg);
          }
        },
        /* Inicializacao */
        initializeSearch() {
          wsMain.modules[
            "advanced-search"
          ].subfunctions.updateOptionsByInfoLojas();
          wsMain.modules["advanced-search"].subfunctions.createDynamicAnchor();

          const searchInput = document.getElementById("input-busca");
          const clearButton = document.getElementById(
            "advanced-search-clear-button"
          );

          wsMain.modules[
            "advanced-search"
          ].subfunctions.updateLocalstorageByQueryParam();

          const resultsDiv =
            wsMain.modules["advanced-search"].subfunctions.createResultsDiv();

          const options = wsMain.tools.getWsData(searchInput, "options");
          wsMain.modules["advanced-search"].subfunctions.updateOptions(options);

          wsMain.modules["advanced-search"].subfunctions.createRecognitionBtn(
            searchInput
          );
          wsMain.modules["advanced-search"].subfunctions.addZindexInput();
          wsMain.modules["advanced-search"].subfunctions.positionMic();
          wsMain.modules["advanced-search"].subfunctions.positionCloseBtn();
          wsMain.modules["advanced-search"].subfunctions.getStoreId();
          wsMain.modules[
            "advanced-search"
          ].subfunctions.defaultMobileSettings();
          wsMain.modules["advanced-search"].subfunctions.prodsTitleMaxLines(
            options
          );
          wsMain.modules["advanced-search"].subfunctions.configureClearButton(
            searchInput,
            clearButton
          );
          wsMain.modules["advanced-search"].subfunctions.configureSearchEvents(
            searchInput,
            resultsDiv
          );
        },
      },
      async get() {
        try {
          if (typeof searchAdvanced_started !== "undefined") {
            return;
          }

          if (!wsMain?.globalData?.infoLoja) {
            setTimeout(() => {
              wsMain.modules["advanced-search"].get();
            }, 1000);
            return;
          }

          searchAdvanced_started = true;

          wsMain.modules["advanced-search"].subfunctions.initializeSearch();

          console.log("busca avancada ");

          return true;
        } catch (error) {
          console.log("test ~ get ~ error:", error);
          return false;
        }
      },
    });
  } catch (e) {
    console.log(`Falha no app advanced search:${e.message}`);
  }

  wsMain.modules["advanced-search"].get();
}, 2000);

/*{Modulo App Fim AdvancedSearch}*/

/* module data info: GoogleAnalytics / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio GoogleAnalytics}*/

(function (w, d) {
    var GA_ID = 'UA-91468744-1';
    var FALLBACK_MS = 10000;

    if (!/^(G|GT|AW|UA|DC)-[A-Z0-9-]+$/i.test(GA_ID)) return;
    w.__wsGaLoader = w.__wsGaLoader || {};
    if (w.__wsGaLoader[GA_ID]) return;
    w.__wsGaLoader[GA_ID] = true;

    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', GA_ID);

    var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'];
    var OPTS = { passive: true, capture: true };
    var fired = false;
    var timer = null;

    // Sem atraso nas etapas do checkout (a conversao nao pode depender de interacao)
    // e na chegada por anuncio (o identificador do clique precisa ser gravado nessa pagina).
    function isImmediate() {
        try {
            if (/^[/](carrinho|checkout|pedido-confirmado)([/]|$)/i.test(w.location.pathname)) return true;
            return /[?&](gclid|gbraid|wbraid|gad_source)=/i.test(w.location.search);
        } catch (e) {
            return false;
        }
    }

    function inject() {
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_ID);
        s.onerror = function () { console.warn('[ws-ga] falha ao carregar ' + GA_ID); };
        d.head.appendChild(s);
    }

    if (isImmediate()) {
        fired = true;
        inject();
        return;
    }

    function afterLoad(fn) {
        if (d.readyState === 'complete') fn();
        else w.addEventListener('load', fn, { once: true });
    }

    function whenIdle(fn) {
        if (w.requestIdleCallback) w.requestIdleCallback(fn, { timeout: 2000 });
        else setTimeout(fn, 1);
    }

    function trigger(e) {
        if (fired || (e && e.isTrusted === false)) return;
        fired = true;
        clearTimeout(timer);
        EVENTS.forEach(function (n) { w.removeEventListener(n, trigger, OPTS); });
        afterLoad(function () { whenIdle(inject); });
    }

    EVENTS.forEach(function (n) { w.addEventListener(n, trigger, OPTS); });
    afterLoad(function () { timer = setTimeout(function () { trigger(); }, FALLBACK_MS); });
})(window, document);


/*{Modulo App Fim GoogleAnalytics}*/

/* module data info: GoogleAds / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio GoogleAds}*/

(function (w, d) {
    var ADS_ID = 'AW-807804338';
    var FALLBACK_MS = 10000;

    if (!/^(AW|G|GT|DC)-[A-Z0-9-]+$/i.test(ADS_ID)) return;
    w.__wsGtagLoader = w.__wsGtagLoader || {};
    if (w.__wsGtagLoader[ADS_ID]) return;
    w.__wsGtagLoader[ADS_ID] = true;

    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    w.gtag('js', new Date());
    w.gtag('config', ADS_ID);

    var EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'mousemove'];
    var OPTS = { passive: true, capture: true };
    var fired = false;
    var timer = null;

    // Sem atraso nas etapas do checkout (a conversao nao pode depender de interacao)
    // e na chegada por anuncio (o identificador do clique precisa ser gravado nessa pagina).
    function isImmediate() {
        try {
            if (/^[/](carrinho|checkout|pedido-confirmado)([/]|$)/i.test(w.location.pathname)) return true;
            return /[?&](gclid|gbraid|wbraid|gad_source)=/i.test(w.location.search);
        } catch (e) {
            return false;
        }
    }

    function inject() {
        var s = d.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_ID);
        s.onerror = function () { console.warn('[ws-ads] falha ao carregar ' + ADS_ID); };
        d.head.appendChild(s);
    }

    if (isImmediate()) {
        fired = true;
        inject();
        return;
    }

    function afterLoad(fn) {
        if (d.readyState === 'complete') fn();
        else w.addEventListener('load', fn, { once: true });
    }

    function whenIdle(fn) {
        if (w.requestIdleCallback) w.requestIdleCallback(fn, { timeout: 2000 });
        else setTimeout(fn, 1);
    }

    function trigger(e) {
        if (fired || (e && e.isTrusted === false)) return;
        fired = true;
        clearTimeout(timer);
        EVENTS.forEach(function (n) { w.removeEventListener(n, trigger, OPTS); });
        afterLoad(function () { whenIdle(inject); });
    }

    EVENTS.forEach(function (n) { w.addEventListener(n, trigger, OPTS); });
    afterLoad(function () { timer = setTimeout(function () { trigger(); }, FALLBACK_MS); });
})(window, document);


/*{Modulo App Fim GoogleAds}*/

/* module data info: Pinterest Tag / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio Pinterest Tag}*/

setTimeout(() => {
    pinterestTag();
}, 4000);


function pinterestTag(){
    try{ 
    const userEmail = document.querySelector('#HD_LVCLI_EMAIL').value
    const tagId = '2612469613558';
    let scriptContent

    if(userEmail != ''){
        scriptContent = `
            !function(e){if(!window.pintrk){window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
            n=window.pintrk;n.queue=[],n.version="3.0";var
            t=document.createElement("script");t.async=!0,t.src=e;var
            r=document.getElementsByTagName("script")[0];
            r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
            pintrk('load', '${tagId}', {em: '${userEmail}'});
            pintrk('page');`
    } else {
        scriptContent = `
            !function(e){if(!window.pintrk){window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
            n=window.pintrk;n.queue=[],n.version="3.0";var
            t=document.createElement("script");t.async=!0,t.src=e;var
            r=document.getElementsByTagName("script")[0];
            r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
            pintrk('load', '${tagId}');
            pintrk('page');`
    }

    const pinterestScript = document.createElement('script');
    pinterestScript.innerHTML = scriptContent;
    
    document.querySelector('head').append(pinterestScript);
    const etapa = document.querySelector('#HdEtapaLoja').value;

    const functions = {
        HOME(){
            if (!objetos) {
                setTimeout(functions.HOME, 1000);
                return;
            };

            if (!objetos.ProdutosGrupos) {
                setTimeout(functions.HOME, 1000);
                return;
            };

            const buttonsHome = document.querySelectorAll('a[data-sku]');
            let arrTotalGrupos = [];
            let todosOsProdutos = [];

            JSON.parse(objetos.ProdutosGrupos).grupos.forEach(grupos => {
                arrTotalGrupos = [...arrTotalGrupos, ...grupos.produtos];
            });
            
            todosOsProdutos = arrTotalGrupos

            const precoProd = todosOsProdutos.map(produto => {
                return {
                    precos: produto.precos,
                    id: produto.id,
                    item_code: produto.codigo
                };
            });
            pintrk('track', 'pagevisit');

            buttonsHome.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    let btnSku = e.target.getAttribute('data-sku');
                    let valueProd ;

                    precoProd.forEach(prod => {
                        if (prod['item_code'] == btnSku) {
                            valueProd = prod.precos['preco_promocao'] || prod.precos['preco'];
                        };
                    });
                    console.log(valueProd)
                    pintrk('track', 'addtocart', {
                        value: valueProd,
                        order_quantity: 1,
                        currency: 'BRL',
                        product_id: btnSku
                    });                    
                });
            });
        },
        LISTAGEM(){
            let prodId
            let wsCategoryArr
            let productCategory

            try {
                if(wsMain){
                    if (!wsMain.globalData.listCategoryProds) {
                        setTimeout(() => {
                            functions.LISTAGEM();
                        }, 2000)
                    };
                }
                prodId = wsMain.globalData.listCategoryProds.produtos
                productCategory = wsMain.globalData.listCategoryProds.migalha
            } catch (error) {
                if (!objetos.ProdutosListagem) {
                    setTimeout(() => {
                        functions.LISTAGEM();
                    }, 2000)
                };
                prodId = JSON.parse(objetos.ProdutosListagem).produtos;
                wsCategoryArr = JSON.parse(objetos.ProdutosListagem).migalha;
                if(wsCategoryArr != null){
                    productCategory = wsCategoryArr.pop().nome;
                }
            }

            pintrk('track', 'pagevisit');

            let searchTerm = window.location.href.split('/0/')[1];

            if(searchTerm){
                pintrk('track', 'search', {
                    search_query: searchTerm,
                });                   
            };

            const prodToSend = prodId.map(elm => {
                return {product_category: productCategory, product_id: elm.id};
            });

            pintrk('track', 'viewcategory', {
                line_items: prodToSend,
            });

            const buttonsHome = document.querySelectorAll('a[data-sku]');
            buttonsHome.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const btnSku = e.target.getAttribute('data-sku');

                    prodId.forEach(elm => {
                        if(elm.codigo == btnSku){
                            pintrk('track', 'addtocart', {
                                value: elm.precos.preco_promocao != 0 ? elm.precos.preco_promocao : elm.precos.preco,
                                order_quantity:1,
                                currency: 'BRL',
                                product_id: btnSku
                            });
                        };
                    });
                });
            });
        },
        PRODUTO(){
            if (!objetos) {
                setTimeout(functions.PRODUTO, 1000);
                return;
            };

            if (!objetos.ProdutoDadosRetorno) {
                setTimeout(functions.PRODUTO, 1000);
                return;
            };


            let productId 
            let valorProduto;
            try {
                const prodSku = document.querySelector('a[data-sku]');
                productId =  prodSku.getAttribute('data-sku')

                const objProduto = JSON.parse(objetos.ProdutoDadosRetorno);
                if(objProduto.precos.preco_promocao != 0)  valorProduto = objProduto.precos.preco_promocao;
                else valorProduto = objProduto.precos.preco;
                
            } catch (error) {
                productId = wsMain.globalData.infoProduto.codigo
                if(wsMain.globalData.infoProduto.precos.preco_promocao != 0) valorProduto = wsMain.globalData.infoProduto.precos.preco_promocao
                else valorProduto = wsMain.globalData.infoProduto.precos.preco;
            }

            const inpQtd = document.querySelector('#TxtQtdAdd');

            const linkBtn = document.querySelectorAll('a[data-sku]')
            pintrk('track', 'pagevisit'); 
            let prodQtd = 1;
            
            if(linkBtn.length > 0){
                linkBtn .forEach(btn => {
                    btn.addEventListener('click', () => {
                        if(inpQtd){
                            prodQtd = inpQtd.value;
                        };
                        pintrk('track', 'addtocart', {
                            value: valorProduto,
                            order_quantity: prodQtd,
                            currency: 'BRL',
                            product_id: productId,
                        });
                    });
                }) 
            }

            const buttonBtn = document.querySelectorAll('button[data-sku]')
                if(buttonBtn.length > 0){
                    document.querySelectorAll('button[data-sku]').forEach(btn => {
                        btn.addEventListener('click', () => {
                            if(inpQtd){
                                prodQtd = inpQtd.value;
                            };
                            pintrk('track', 'addtocart', {
                                value: valorProduto,
                                order_quantity: prodQtd,
                                currency: 'BRL',
                                product_id: productId,
                            });
                        });
                    }) 
                }        
        },
        FinalPagamento(){
            if (!orderData.products || !orderData.customer) {
                setTimeout(functions.FinalPagamento, 1000);
                return;
            };
            let orderId = document.querySelector('.LV_CheckoutSmart_NumeroPedidoShow > strong').innerHTML

            if (!orderId) {
                setTimeout(functions.FinalPagamento, 1000);
                return;
            };
            
            const lineItems = orderData.products.map((produto) => {
                return {
                    product_name: produto.title,
                    product_id: produto.sku,
                    product_price: produto.unit_price,
                    product_quantity: produto.quantity
                };
            });

            let orderQuantityArr = [];
            lineItems.forEach(prod => {
                return orderQuantityArr.push(prod.product_quantity);
            });

            const orderQuantityToSend = eval(orderQuantityArr.join('+'));

            pintrk('track', 'pagevisit');
            
            pintrk('track', 'checkout', {
                order_id: orderId.toString(),
                value: orderData.total,
                order_quantity: orderQuantityToSend,
                currency: 'BRL',
                line_items: lineItems,
              });
        },
        cadastro(){
            if (!objetos.InfosLojas) {
                setTimeout(functions.cadastro, 1000);
                return;
            };
            pintrk('track', 'pagevisit');
            pintrk('track', 'signup');
        }
    };

    functions[etapa] != undefined ? functions[etapa]() : pintrk('track', 'pagevisit');
    }catch(e){
        console.log(e.message);
    }
};

/*{Modulo App Fim Pinterest Tag}*/

/* module data info: Favoritos / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio Favoritos}*/

var WsFavoritos = true;

setTimeout(() => {
        try {

            isReady("allModulosOk", "FuncaoVerifFavoritos()");

	    isReady("allModulosOk", FuncaoVerifFavoritos());

            window.setTimeout("funcGetFavoritos()", 500);

        } catch (e) { }
    }
,1000);


function funcAddFavoriteWs(prod) {

    try {

        /*localStorage["prodsWsFav"] = null;*/

        StopFavoriteVerif = true;

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));

        if (!WsFavoritesProds) {
            WsFavoritesProds = [];
        }

        var exist = false;

        for (a = 0; a < WsFavoritesProds.length; a++) {
            if (WsFavoritesProds[a].id == prod) {
                exist = true;
            }
        }

        if (!exist) {

            var element = {};
            element.id = prod;
            WsFavoritesProds.push(element);

        } else {

            funcRemoveFavoriteWs(prod);
            return;

        }

        $("[data='prod-favorite-link-" + prod + "']").addClass("active");
        localStorage.setItem('prodsWsFav', JSON.stringify(WsFavoritesProds));

        window.setTimeout("funcSaveFavoriteWs()", 1000);

    } catch (e) {
        console.log(e.message);
    }

}

function funcRemoveFavoriteWs(prod) {

    try {

        StopFavoriteVerif = true;

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        var WsFavoritesProdsNew = [];

        if (!WsFavoritesProds) {
            return;
        }

        /*console.log("Removendo favorito");*/
        for (a = 0; a < WsFavoritesProds.length; a++) {
            if ((WsFavoritesProds[a].id != prod)) {

                /*console.log("Mantido " + WsFavoritesProds[a].id);*/
                var element = {};
                element.id = WsFavoritesProds[a].id;
                WsFavoritesProdsNew.push(element);

            } else {
                /*console.log("Não Mantido " + WsFavoritesProds[a].id);*/
            }
        }
        
        $("[data='prod-favorite-link-" + prod + "']").removeClass("active");
        localStorage.setItem('prodsWsFav', JSON.stringify(WsFavoritesProdsNew));

        window.setTimeout("funcSaveFavoriteWs()", 1000);

    } catch (e) {
        console.log(e.message);
    }

}

function FuncaoVerifFavoritos() {
    window.setTimeout("FuncaoVerifFavoritosStart()", 2000);
}

var limitFavoritVerif = 0;
var StopFavoriteVerif = false;
function FuncaoVerifFavoritosStart() {

    var CliLogou = localStorage.getItem('favoritesCliId');
    var CliId = $("#HD_LVCLI_ID").val();

    limitFavoritVerif++;
    if (limitFavoritVerif > 5) { return; }

    if ($("#HdSubEtapa").val() == "FAVORITOS" && limitFavoritVerif == 1) {
        funcListaFavoritos();
    }

    try {

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        
        if (!WsFavoritesProds) {
            return;
        }

        for (a = 0; a < WsFavoritesProds.length; a++) {
            try {
                if (!StopFavoriteVerif) {
                    $("[data='prod-favorite-link-" + WsFavoritesProds[a].id + "']").addClass("active");
                }

            } catch (e) { }
        }

        var needSave = localStorage.getItem('prodsWsFav_saved');
        
        var CliLogou = localStorage.getItem('favoritesCliId');
        var CliId = $("#HD_LVCLI_ID").val();

        if (CliLogou != CliId) {
            if (CliId != "0" && CliId != "") {
                needSave = "0";
                localStorage.setItem('favoritesCliId', CliId);
            }
        }

        if (needSave == "0") {
            funcSaveFavoriteWs();
        }

    } catch (e) {
        console.log(e.message);
    }

    window.setTimeout("FuncaoVerifFavoritosStart()", 2000);

}

var varCanSaveFavorite = true;
function funcSaveFavoriteWs() {
    try {

        var JSON = localStorage.getItem('prodsWsFav');
        var CliId = $("#HD_LVCLI_ID").val();

        var saved = "0";

        if (CliId && JSON != "") {

            if (CliId != "" && CliId != "0") {

                if (varCanSaveFavorite) {

                    varCanSaveFavorite = false;

                    let urlAPI = ApiWS.UrlApi ? ApiWS.UrlApi : UrlApi;
                    let VersaoApi = 'api-loja-v2';

                    var Token = $("#HdTokenLojaTemp").val();
                    var URLget = urlAPI + "/" + VersaoApi + "/produtos/favoritos-save";
                    var Parametros = "LOJA=" + ApiWS.LV + "&LvToken=" + Token + "&CliId=" + CliId + "&JSON=" + JSON + "&cacheclear=" + Math.floor((Math.random() * 1000) + 1);

                    $.ajax({
                        type: "GET",
                        url: URLget,
                        data: Parametros,
                        beforeSend: function () { },
                        error: function (e) { console.log("falha ao salvar favoritos " + e.message); varCanSaveFavorite = true; },
                        success: function (retorno) {

                            saved = "1";

                            varCanSaveFavorite = true;
                            console.log("Favoritos saved :" + retorno);
                            if (retorno == "sucesso") {

                            }

                            localStorage.setItem('prodsWsFav_saved', saved);

                        }
                    });

                }

            }

            localStorage.setItem('prodsWsFav_saved', saved);

        }

        
        
    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

function funcListaFavoritos() {
    try {

        console.log("Lista Favoritos");

        var CliId = $("#HD_LVCLI_ID").val();
        var LvId = $("#HD_LV_ID").val();

        if (!CliId) { window.location.href = "/login/" + LvId + "/login"; return; }
        if (CliId == "" || CliId == "0") { window.location.href = "/login/" + LvId + "/login"; return; }

        var Migalha = '<li><a href="/home.aspx?LV_ID=' + LvId + '">P&aacute;gina inicial</a></li><li class="separador">/</li><li><a href="/produtos/favoritos" class="active">Favoritos</a></li>';
        $("#lista-migalha").append(Migalha).show();
        $(".paginacao-ordem").remove();


    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

function funcGetFavoritos() {
    try {

        console.log("Lendo Favoritos do cliente");

        var WsFavoritesProds = JSON.parse(localStorage.getItem('prodsWsFav'));
        var CliId = $("#HD_LVCLI_ID").val();

        if (CliId && !WsFavoritesProds) {

            if (CliId != "" && CliId != "0") {

                let urlAPI = ApiWS.UrlApi ? ApiWS.UrlApi : UrlApi;
                let VersaoApi = 'api-loja-v2';

                var Token = $("#HdTokenLojaTemp").val();
                var URLget = urlAPI + "/" + VersaoApi + "/produtos/favoritos-list";
                var Parametros = "LOJA=" + ApiWS.LV + "&LvToken=" + Token + "&CliId=" + CliId + "&cacheclear=" + Math.floor((Math.random() * 1000) + 1);

                $.ajax({
                    type: "GET",
                    url: URLget,
                    data: Parametros,
                    beforeSend: function () { },
                    error: function (e) { console.log("falha ao ler favoritos " + e.message); varCanSaveFavorite = true; },
                    success: function (retorno) {
                        console.log("Favoritos Get:" + retorno);
                        if (retorno.indexOf("JSON:") >= 0) {

                            localStorage.setItem('prodsWsFav', retorno.replace("JSON:", ""));

                        }

                    }
                });

            }

        }
        

    } catch (e) {
        console.log("Falha ao salvar os favoritos"+ e.message);
    }
}

/*{Modulo App Fim Favoritos}*/

/* module data info: Google Safe Browsing / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio Google Safe Browsing}*/

setTimeout(() => {
  
console.log("Google Safe Browsing OK");

try{
WsSecurityStamps("Google Safe Browsing", "https://transparencyreport.google.com/safe-browsing/search?url="+window.location.host, "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/google-safe-browsing.svg");
}catch(e){}

try{
let data = [
      {
        name: 'Google Safe Browsing',
        url: "https://transparencyreport.google.com/safe-browsing/search?url="+window.location.host,
        image: "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/google-safe-browsing.svg"
      }]
wsMain.modules['footer-badges'].create(data);
}catch(e){}


}, "1 second");

/*{Modulo App Fim Google Safe Browsing}*/

/* module data info: SSL LetsEncrypt / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio SSL LetsEncrypt}*/

setTimeout(() => {
  
console.log("Selo Lets Encrypt Inserido Vrs1.1");

try{
WsSecurityStamps("SSL Lets Encrypt", "", "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/LetsEncrypt.svg");
}catch(e){}

try{
let data = [
      {
        name: 'SSL Lets Encrypt',
        url: 'javascript:void()',
        image: "https://cdns3.webstore.net.br/files/0ws/wireframe/selos/LetsEncrypt.svg?27092022"
      }]
wsMain.modules['footer-badges'].create(data);
}catch(e){}

}, 1000);

/*{Modulo App Fim SSL LetsEncrypt}*/

/* module data info: CookieConfirm / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio CookieConfirm}*/

(function () {
  "use strict";

  var STORAGE_KEY = "webstore_cookie_consent";
  var STYLE_ID = "webstore-cookie-consent-style";
  var BAR_ID = "webstore-cookie-consent-bar";

  function cookiesForamAceitos() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "accepted";
    } catch (error) {
      return false;
    }
  }

  function adicionarEstilos() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement("style");

    style.id = STYLE_ID;
    style.textContent = `
      #${BAR_ID} {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
        box-sizing: border-box;
        padding: 14px 30px;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
        color: #222;
        font-family: Arial, sans-serif;
        font-size: 12px;
        line-height: 1.4;
      }

      #${BAR_ID} .cookie-consent-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        width: 100%;
        max-width: 850px;
        margin: 0 auto;
      }

      #${BAR_ID} .cookie-consent-text {
        margin: 0;
      }

      #${BAR_ID} .cookie-consent-button {
        flex-shrink: 0;
        padding: 7px 18px;
        background-color: #FFF;
        border: 1px solid #222;
        border-radius: 3px;
        color: #222;
        font-family: inherit;
        font-size: 11px;
        line-height: 1;
        text-transform: uppercase;
        cursor: pointer;
        transition: opacity 0.2s ease;
      }

      #${BAR_ID} .cookie-consent-button:hover {
        opacity: 0.8;
      }

      @media (max-width: 600px) {
        #${BAR_ID} {
          padding: 12px 16px;
        }

        #${BAR_ID} .cookie-consent-content {
          gap: 12px;
        }

        #${BAR_ID} .cookie-consent-text {
          flex: 1;
          font-size: 11px;
        }

        #${BAR_ID} .cookie-consent-button {
          padding: 8px 12px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function criarBarraDeCookies() {
    if (
      cookiesForamAceitos() ||
      document.getElementById(BAR_ID)
    ) {
      return;
    }

    adicionarEstilos();

    var barra = document.createElement("div");
    var conteudo = document.createElement("div");
    var texto = document.createElement("p");
    var botao = document.createElement("button");

    barra.id = BAR_ID;
    conteudo.className = "cookie-consent-content";

    texto.className = "cookie-consent-text";
    texto.textContent =
      "Este site usa cookies para gerar estatísticas e melhorar sua experiência de navegação. Ao continuar, você declara que está de acordo.";

    botao.type = "button";
    botao.className = "cookie-consent-button";
    botao.textContent = "Aceitar";

    botao.addEventListener("click", function () {
      try {
        localStorage.setItem(STORAGE_KEY, "accepted");
      } catch (error) {
      }

      barra.remove();
    });

    conteudo.appendChild(texto);
    conteudo.appendChild(botao);
    barra.appendChild(conteudo);

    document.body.appendChild(barra);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      criarBarraDeCookies
    );
  } else {
    criarBarraDeCookies();
  }
})();

/*{Modulo App Fim CookieConfirm}*/

/* module data info: DataLayer / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio DataLayer}*/

console.log("modDatalayer started Vrs.28-09-2026");

window.addEventListener("load", () => {
    if (document.querySelector("#HdEtapaLoja").value == "HOME") { setTimeout(trigger_dataLayer, 5500); }
    else { setTimeout(trigger_dataLayer, 1000); }
});

function sendShippingEvent() {
  console.log('passou no shipment info')
  const input = document.querySelector("#ws-carrinhoNovo .frete .cepInput input");

  if(!input) return

  return ['add_shipping_info', {
    currency: 'BRL',
    value: cartJson.subtotal,
    shipping_tier: "Ground",
    items: cartJson.products.map(item => {
      return {
        item_id: item.sku,
        item_name: item.name,
        quantity: item.quantity,
        price: item.real_price
      }
    })
  }]
}

function sendPaymentEvent() {
  console.log('passou no payment info')
  const inputs = document.querySelectorAll(".LV_CheckoutSmart_Pagamento_Div .LV_CheckoutSmart_FormasPagamento_Div div .ListaFormasPgto li label");

  if(!inputs || !inputs.length) return;

  let selected = ''

  inputs.forEach(inp => {
    if(inp.classList.contains('Selected')) {
      if(inp.querySelector('.NomePagamento')) {
        selected = inp.querySelector('.NomePagamento').textContent;
      }
    }
  })

  if (!selected) return;

  return ['add_payment_info', {
    currency: 'BRL',
    value: orderData.total,
    payment_type: selected,
    items: orderData.products.map(item => {
      return {  
        item_id: item.sku,
        item_name: item.title,
        quantity: item.quantity,
        price: item.unit_price
      }
    })
  }]
}

function createEventTag(events) {
  if (!events) return;

  let scriptElem = document.createElement('script');

  events = Array.isArray(events[0]) ? events : [events];

  events.forEach(event => {
    let [eventName, eventData] = event;
    scriptElem.innerHTML += `gtag('event', '${eventName}', ${JSON.stringify(eventData, null, 2)});\n`;
  })

  let scriptConfig = document.createElement('script');
  scriptConfig.innerHTML = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());`


  if (typeof gtag === 'undefined') document.querySelector('head').append(scriptConfig)
  document.querySelector('head').append(scriptElem)
}

function trigger_dataLayer() {
  let actualStep = document.querySelector('#HdEtapaLoja').value;

  async function waitUntil(condition) {
    return await new Promise(resolve => {
      const interval = setInterval(() => {
        try {
          if (condition()) {
            resolve();
            clearInterval(interval);
          };
        } catch (err) { }
      }, 1000);
    });
  }

  function getProd(element) {
    return {
      ['item_id']: element.codigo,
      ['item_name']: element.nome,
      ['price']: parseFloat(element.precos?.preco_promocao ? element.precos?.preco_promocao : element.precos?.preco),
      ['item_brand']: element.fabricante?.nome
    }
  }

  function getAllProds() {
    let allProds = [];

    Object.keys(wsMain.globalData).forEach(columnName => {
      if ((columnName == 'listHomeProds' || columnName == 'listCategoryProds') && wsMain.globalData[columnName]) {
        wsMain.globalData[columnName].produtos.forEach(prod => allProds.push(getProd(prod)))
      }
      if (columnName == 'listGroupProds' && wsMain.globalData[columnName]) {
        wsMain.globalData[columnName].grupos.forEach(group => {
          group.produtos.forEach(prod => allProds.concat(getProd(prod)))
        })
      }
    });

    return allProds;
  }

  function getDeparment(objeto) {
    if (!objeto || !objeto.length) return null;

    for (const item of objeto) {
      if (item.atual) return item;

      if (item.hasOwnProperty("subcategorias")) {
        const categoriaEncontrada = getDeparment(item.subcategorias);
        if (categoriaEncontrada !== null) return categoriaEncontrada;
      }
    }

    return null;
  }

  function getEmailFromLocalStorage() {
    const email = localStorage.getItem("email");
    return email ? email : false;
  }

  const dataLayerFunctions = {
    'HOME': async () => {
      let dataFunction = () => wsMain.globalData?.listHomeProds || wsMain.globalData?.listGroupProds;

      await waitUntil(dataFunction);

      return ['view_item_list', {
        item_list_name: 'Produtos Home',
        items: getAllProds()
      }]
    },
    'LISTAGEM': async () => {
      let dataFunction = () => (wsMain.globalData?.listCategoryProds && wsMain.globalData?.infoCategory);
      await waitUntil(dataFunction);

      let returnArr = [

        ['view_item_list', {
          item_list_name: getDeparment(wsMain.globalData.infoCategory.Categorias)?.nome || 'Listagem de Produtos',
          item_list_id: getDeparment(wsMain.globalData.infoCategory.Categorias)?.id || 'search',
          items: getAllProds()
        }]

      ];

      if (window.location.pathname.indexOf('/busca/') != -1) {
        let searchArr = window.location.pathname.split('/');

        returnArr.push(['view_search_results', {
          search_term: searchArr[searchArr.length - 1]
        }])
      }

      return returnArr
    },
    'PRODUTO': async () => {
      let dataFunction = () => (wsMain.globalData?.infoProduto && wsMain.globalData?.infoCategory);
      await waitUntil(dataFunction);

      return ['view_item', {
        currency: 'BRL',
        value: getProd(wsMain.globalData.infoProduto).price,
        items: [getProd(wsMain.globalData.infoProduto)]
      }]
    },
    'FORMAS_PAGAMENTO': async () => {
      const arrToReturn = ['begin_checkout', {
        currency: 'BRL',
        value: orderData.total,
        items: orderData.products.map(item => {
          return {
            item_id: item.sku,
            item_name: item.title,
            quantity: item.quantity,
            price: item.unit_price
          }
        })
      }]

      getEmailFromLocalStorage() ? arrToReturn[1].email = getEmailFromLocalStorage() : null;

      return arrToReturn;
    },
    'FinalPagamento': async () => {
      return ['purchase', {
        currency: 'BRL',
        email: orderData.customer.email,
        name: orderData.customer.name,
        value: orderData.total,
        transaction_id: orderData.order_id,
        items: orderData.products.map(item => {
          return {
            item_id: item.sku,
            item_name: item.title,
            quantity: item.quantity,
            price: item.unit_price
          }
        })
      }]
    }
  }

  if (typeof callbackShippingSelected !== 'undefined' && Array.isArray(callbackShippingSelected)) {
    callbackShippingSelected.push("createEventTag(sendShippingEvent())");
  }

  if (typeof callbackPaymentSelected !== 'undefined' && Array.isArray(callbackPaymentSelected)) {
    callbackPaymentSelected.push("createEventTag(sendPaymentEvent())");
  }

  async function print_dataLayer() {
    try {
      let scriptElem = document.createElement('script');

      let events = await dataLayerFunctions[actualStep]();

      events = Array.isArray(events[0]) ? events : [events];

      events.forEach(event => {
        let [eventName, eventData] = event;
        scriptElem.innerHTML += `gtag('event', '${eventName}', ${JSON.stringify(eventData, null, 2)});\n`;
      })

      let scriptConfig = document.createElement('script');
      scriptConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());`


      if (typeof gtag === 'undefined') document.querySelector('head').append(scriptConfig)
      document.querySelector('head').append(scriptElem)
    } catch (err) {
      console.log('Erro inesperado do DataLayer \n', err);
    }
  }

  if (Object.keys(dataLayerFunctions).includes(actualStep)) print_dataLayer();
}


/*{Modulo App Fim DataLayer}*/

/* module data info: Webstore Assinatura / all app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio Webstore Assinatura}*/

setTimeout(() => {
    if (typeof notWsSign === "undefined") {
        const wsClass = Math.floor(Math.random() * 1000);
        const nomeLoja = $("#HD_LV_NOME").val() || "";
        const wsUrl =
            "https://www.webstore.com.br/?utm_source=" +
            encodeURIComponent(nomeLoja) +
            "&utm_medium=referral&utm_campaign=customers&utm_content=webstore";

        const imgSrcAttribute =
            typeof wsMain !== "undefined" ? "data-wsjs-src" : "src";

        $("body").append(`
            <div id="ws_sign_${wsClass}" class="ws${wsClass}">
                <div id="ws${wsClass}">
                    <div>
                        <span>Tecnologia</span>
                        <a href="${wsUrl}"
                           target="_blank"
                           rel="noopener"
                           title="Webstore | Plataforma de E-commerce para criar ou montar loja virtual">
                            <img ${imgSrcAttribute}="/logo/logo-webstore.svg"
                                 data-wsjs-lazyload="scroll"
                                 class="lazyload"
                                 alt="Webstore plataforma de e-commerce"
                                 width="111"
                                 height="16" />
                        </a>
                    </div>
                </div>
            </div>
        `);

        $("body").append(`
            <style rel="wstokencss83130_93483081">
                body .ws${wsClass} {
                    background-color: #FFF !important;
                    padding: 20px;
                }

                body .ws${wsClass} #ws${wsClass} {
                    display: table !important;
                    margin: 0 auto !important;
                    font-size: 11px !important;
                    font-family: Arial !important;
                    color: #666;
                    clear: both !important;
                }

                body .ws${wsClass} div span {
                    display: inline-block !important;
                    padding: 0px 6px !important;
                    float: left !important;
                }

                body .ws${wsClass} div a {
                    display: inline-block !important;
                    opacity: 1;
                    -webkit-filter: grayscale(100%);
                    filter: grayscale(100%);
                    transition: -webkit-filter 0.5s, filter 0.5s, opacity 0.5s;
                    padding-top: 4px;
                }

                body .ws${wsClass} div a img {
                    width: 111px;
                }

                body .ws${wsClass} div a:hover {
                    opacity: 1 !important;
                    -webkit-filter: grayscale(0%) !important;
                    filter: grayscale(0%) !important;
                }
            </style>
        `);
    }
}, 2000);

/*{Modulo App Fim Webstore Assinatura}*/

/* module data info: Whatsapp / in app added at (2026-10-16 00:30:12) */

/*{Modulo App Inicio Whatsapp}*/

function StartWhatsWs() {

    try {

        var data1 = '11922769997';
	var data2 = 'ID';

	console.log("Whatsapp iniciado "+ data1);

        var LinkUse = "https://web.whatsapp.com/send?phone=55";
        var w = window.innerWidth;

        if (w < 900) {
            LinkUse = "https://wa.me/55";
        }

        $("body").append("<a href='" + LinkUse + data1 + "' id='btwhatstalk' title='Fale conosco pelo Whatsapp' target='_blank' class='whats-ws-link whatslink"+data2+"'>" +
                         "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path d='M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z'/></svg>" +
                         "</a>");

	window.setTimeout("actionWhatsWs()", 1000);


    } catch (e) {
        console.log("Falha app Whatsapp:" + e.message);
    }

}

function actionWhatsWs(){
	$("#btwhatstalk").click(function(){

		let scriptConfig = document.createElement('script');
    
		scriptConfig.innerHTML = `try{gtag('event', 'chat_initiated');}catch(e){}`;

		document.querySelector('body').append(scriptConfig)

	});
}

window.setTimeout("StartWhatsWs()", 1000);

/*{Modulo App Fim Whatsapp}*/

/* module data info: All Modulos Add 2026-10-16 00:30:12 */